import { render } from "./WebReportDetail.vue?vue&type=template&id=1d31e931"
import script from "./WebReportDetail.vue?vue&type=script&lang=js"
export * from "./WebReportDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__